/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import '@lm-nx-frontend/lm-inf-core';

export interface ProductConfiguratorConfig {}

declare module '@lm-nx-frontend/lm-inf-core' {
  interface Config {
    productConfigurator?: ProductConfiguratorConfig;
  }
}
